import type { QueryHookOptions } from "@apollo/client";
import { useQuery, gql } from "@apollo/client";

import type { StoreFragment } from "@shared/data/fragments/StoreFragment/StoreFragment.fragment";
import { STORE_FRAGMENT } from "@shared/data/fragments/StoreFragment/StoreFragment.fragment";

const Store_Shared_Query = gql`
  query Store_Shared_Query {
    currentStore {
      ...StoreFragment
    }
    currentOffice {
      id
    }
  }
  ${STORE_FRAGMENT}
`;

interface StoreQueryData {
  currentStore: StoreFragment;
  currentOffice: {
    id: string;
  };
}

const useStoreQuery = (options?: QueryHookOptions<StoreQueryData>) =>
  useQuery<StoreQueryData>(Store_Shared_Query, options);

export type { StoreQueryData };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { useStoreQuery, Store_Shared_Query };
